import { isFirstPartyLink } from '@confluence/content-smartlinks/entry-points/smartLinkBatchHelpers.ts';

import type { EnhancedSmartLink } from '../../utils/smartLinkTypes.ts';

export type GdriveConnectionIneligibleReason = 'noSiteWideDriveLinks' | 'alreadyAuthenticated';

export const hasOnlyFirstPartyLinks = (links: EnhancedSmartLink[]): boolean =>
	links.length > 0 && links.every((link) => isFirstPartyLink(link.url));

export const getGdriveConnectionIneligibleReason = ({
	hasSiteWideDriveLinks,
	isAuthenticated,
}: {
	hasSiteWideDriveLinks: boolean;
	isAuthenticated: boolean;
}): GdriveConnectionIneligibleReason | undefined => {
	if (!hasSiteWideDriveLinks) {
		return 'noSiteWideDriveLinks';
	}
	if (isAuthenticated) {
		return 'alreadyAuthenticated';
	}
	return undefined;
};
